import React, { useState } from 'react';
import { Box, Typography, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PayoutRequests from './PayoutRequests';
import OrderPayments from './OrderPayments';

const AdminTransactions: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'payout-requests' | 'order-payments'>('payout-requests');
  const [searchQuery, setSearchQuery] = useState('');

  const tabs = [
    { key: 'payout-requests', label: 'Payout requests', badgeCount: 0 },
    { key: 'order-payments', label: 'Order payments', badgeCount: 0 },
  ];

  return (
    <Box
      className="page-container"
      sx={{
        padding: {
          xs: '24px 16px',
          sm: '40px 40px',
          md: '40px 80px',
        },
        gap: '24px',
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Page Header */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '16px',
          flexShrink: 0,
          flexWrap: 'wrap',
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: '44px',
            fontWeight: 700,
            lineHeight: 1.15,
            letterSpacing: '-1%',
            color: 'var(--palette-light-text-primary-value-hex)',
          }}
        >
          Transactions
        </Typography>

        {/* Centralized Search */}
        <TextField
          placeholder={activeTab === 'payout-requests' ? 'Search payout requests...' : 'Search transactions...'}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: 'var(--palette-light-text-secondary-value-hex)' }} />
              </InputAdornment>
            ),
          }}
          sx={{
            width: '320px',
            '& .MuiOutlinedInput-root': {
              height: '56px',
              backgroundColor: 'var(--palette-light-background-secondary-value-hex)',
              borderRadius: '12px',
              fontSize: 'var(--palette-light-font-size-default-value)',
              '& fieldset': {
                border: 'none',
              },
            },
          }}
        />
      </Box>

      {/* Content Section */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignSelf: 'stretch', gap: '32px', width: '100%', flex: 1, overflow: 'hidden' }}>
        {/* Tab Content */}
        {activeTab === 'payout-requests' && (
          <PayoutRequests activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} searchQuery={searchQuery} />
        )}
        {activeTab === 'order-payments' && (
          <OrderPayments activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} searchQuery={searchQuery} />
        )}
      </Box>
    </Box>
  );
};

export default AdminTransactions;

